import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconId(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path fill="currentColor" d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 3a1 1 0 1 0-2 0v1.062A8.004 8.004 0 0 0 4.062 11H3a1 1 0 1 0 0 2h1.062A8.004 8.004 0 0 0 11 19.938V21a1 1 0 1 0 2 0v-1.062A8.004 8.004 0 0 0 19.938 13H21a1 1 0 1 0 0-2h-1.062A8.004 8.004 0 0 0 13 4.062V3Zm5 9a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
